<div class="d-flex flex-row gap-3 align-items-center">
  <button class="btn btn-sm btn-light" [ngbPopover]="popContent" placement="bottom-left" container="body"><i
      class="bi bi-three-dots-vertical"></i></button>
</div>
<ng-template #popContent>
  <div class="d-flex flex-column gap-1 justify-content-start" >
    <button class="btn border-0 btn-action" (click)="updateStatus('draft')">Change to Draft</button>
    <button class="btn border-0 btn-action" (click)="updateStatus('deactivated')">Deactivate</button>
    <button class="btn border-0 btn-action text-danger" (click)="deleteRate()">Delete</button>
    <button class="btn border-0 btn-action">Edit</button>
    <button class="btn border-0 btn-action" (click)="openAssignGroup()">Assign to Group</button>
  </div>
</ng-template>